import React from "react";

import { toast } from "react-toastify";

import { push } from "connected-react-router";
import { updateStep } from "../CreateWizard/reducer";

const UPDATE_FIELD = "agentStepByStep/UPDATE_FIELD";

const initialState = {
  stepResponses: undefined
}

function agentStepByStepReducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_FIELD:
      return {
        ...state,
        [action.key]: action.data
      };
    default:
      return state;
  }
}

/* Selectors */
export function getBase(state) {
  return state.agentStepByStep;
}

export function getStepResponses(state) {
  return getBase(state)?.stepResponses;
}

/* Actions */
export function updateStepResponses(stepResponses) {
  return (dispatch, getState) => {
    console.log("updateStepResponses", stepResponses);

    return dispatch({ type: UPDATE_FIELD, key:"stepResponses", data: stepResponses });
  };
}

export default agentStepByStepReducer;